import React from 'react';

const initialRole = window.localStorage.getItem('Alutiiq-PreQualificationPortal/role') || 'General Contractor';

type RoleContextValue = [
  string,
  (value: string) => void,
]
const RoleContext = React.createContext({ role: 'General Contractor', setRole: (_value: string) => {} });

const RoleContainer = ({ children }: any) => {
  const [role, setRole]: RoleContextValue = React.useState<string>(initialRole);
  window.localStorage.setItem('Alutiiq-PreQualificationPortal/role', role)
  
  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
}

export default RoleContainer;

export { RoleContext };
